import { polyglot } from '../../fit-polyglot/fit-polyglot-behavior';

export function durationOptions(state = { durationOptions: [] }, action) {
  if (state.durations && state.labels && state.labels.Duration && state.labels.Duration.OptionLabel) {
    const durationOptions = state.durations.map((duration) => ({ Value: `${duration}`, Label: polyglot.t(state.labels.Duration.OptionLabel, { smart_count: duration || 0 }) }));
    return {
      ...state,
      durationOptions,
    };
  }
  return state;
}
